<template>
    <v-alert type="success" v-if="response.status=='OK' && response.type=='new'" dismissable @click="reset()">
      <span v-if="response.message">
        {{response.message}}
        </span>
      <span v-else>
        Je hebt {{response.stamps}} stempels gekregen van {{response.host.name}} voor je volgende bestellingen.
        <br>
        
      </span>
        <slot name="success" v-bind:host="response.host">
        <v-btn text @click="reset(null,true)" class="float-right">OK</v-btn>
        </slot>
    </v-alert>
     <v-alert :color="$attrs.color"  v-else-if="response.status=='OK' && response.type=='existing'" dismissable @click="reset()">
        Je hebt deze code al eens gebruikt en reeds {{response.stamps}} stempels gekregen van {{response.host.name}}.
        <br><v-btn text @click="reset()" class="float-right">Sluiten</v-btn>
    </v-alert>
     <v-alert :color="$attrs.color" v-else-if="response.status=='ERROR'" dismissable @click="reset()">
        Ongeldige of verlopen code, probeer het nogmaals.
          <br><v-btn text @click="reset()" class="float-right">OK</v-btn>
    </v-alert>
    <div v-else-if="showCode || show">
     <character-input v-bind="$attrs"
                :mask="['#', '#', '#', '#', '#']"
                ref="zipinput"
                :rules="[$config.rules.required, $config.rules.code5]"
                v-model="code"
                @keyup="uppercase"
                :autofocus="false"
                :size="size" @finish="collect"
                :hint="hinttext" :dark="dark"
                style="width: 300px"
              ></character-input>
              <div class="text-body-1 mt-2" v-if="hinttext" v-text="hinttext"/>
     <!--v-text-field  v-bind="$attrs" class="pl-2 primary--text py-0 my-0 text-h6 text-capitalize"
              prepend-icon="closed_caption" 
              @keyup="uppercase"
              v-model="code"
              name="code"
              :placeholder="placeholder"
              background-color="transparent"
              :autofocus="autofocus"
              :loading="loading"
              :hint="hinttext"
              clearable
              :persistent-hint="hinttext?true:false"
              @blur="if (!code && !show) showCode = false"
              v-on:keydown.enter.prevent="collect"
            >
            <template v-slot:append-outer>
                <v-btn text class="float-right" @click="collect" color="primary" :loading="loading" :disabled="!isValid">Check</v-btn>
            </template>
            </v-text-field-->
            
      </div>
    <v-btn v-bind="$attrs" class="primary--text mx-auto" v-else-if="!editOnly" :loading="loading" text @click="edit" v-text="text"></v-btn>

</template>

<script>
import { mapGetters } from "vuex";
import CharacterInput from "../components/CharacterInput.vue";
export default {
   components: {
    CharacterInput
  },
  props: {
    value: {
      type: String,
      default: function () {
        return null
      },
    },
    text: {
      type: String,
      default: function () {
        return 'Actiecode'
      },
    },
    placeholder: {
      type: String,
      default: function () {
        return 'Vul je actiecode in'
      },
    },
    hint: {
      type: String,
      default: function () {
        return null
      },
    },
     show: {
      type: Boolean,
      default: function () {
        return null
      },
    },
     dark: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    editOnly: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    size: {
      type: Number,
      default: function () {
        return 4
      },
    },
  },
   data: () => ({
    loading: false,
    showCode: false,
    code: null,
    response: {},
    autofocus: false,
    hinttext: "",
    timer: null
  }),
  computed: {
    ...mapGetters(["user"]),
    isValid(){
      return (this.code && this.code.length>3)
    }
  },
  mounted(){
    this.showCode = this.show
    this.hinttext = this.hint
    this.code = this.value
    console.log('mounted', this.autofocus)
  },
  watch:{
    showCode(value){
      this.$emit('active',this.showCode)
    }
  },
  methods: {
    edit(){
      this.showCode=true
    },
      reset(res, success){
          this.response = res || {}
          
          if (success) {
            this.$emit('success', this.response.code)
          }
          this.loading=false
          this.showCode = false
          
      },
      uppercase() {
        this.code = this.code.toUpperCase();
    },
    async collect(){
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(async ()=>{
          await this.collectT()
        },500)
    },
    async collectT(){
      this.loading=true
      try {  
        let response = await this.$http.post("/api/host/code/" + this.code.toUpperCase(), {index: this.user ? this.user._id : null, source: 'stamp'});
        response.data.code = this.code.toUpperCase()
        this.reset(response.data, this.response.status=='OK' && this.response.type=='new')
        if (this.response.status=='OK' && this.response.type=='new') this.$emit('input', this.response)
      }catch(e){
        this.hinttext = 'Code kan niet opgehaald worden probeer het later nogmaals'
        this.reset(null)
      }
      
    },
  }
}
</script>


